import { isEmpty } from 'lodash';
import React from 'react';

import { LifecycleStatus } from '@ndvr/portfolio-api';

import { formatDateTime } from 'utils';
import { cn } from 'utils/cn';

import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

interface StatusBadgeProps {
    status: LifecycleStatus;
    className?: string;
    liveDate?: string;
    closedAt?: string;
}

export const StatusBadge = ({ status, className, liveDate, closedAt }: StatusBadgeProps) => {
    const badge = (
        <Badge
            variant="secondary"
            className={cn(
                status === LifecycleStatus.REAL
                    ? 'bg-green-100 text-green-800 hover:bg-green-100'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-100',
                className,
            )}
        >
            {status === LifecycleStatus.REAL && 'Linked'}
            {status === LifecycleStatus.DRAFT && 'Not Linked'}
            {status === LifecycleStatus.CLOSED && 'Closed'}
            {status === LifecycleStatus.ONBOARDING && 'Onboarding'}
        </Badge>
    );

    // Only show tooltip if we have date information
    if (status === LifecycleStatus.CLOSED && !closedAt) {
        return badge;
    }
    if (status === LifecycleStatus.REAL && !liveDate) {
        return badge;
    }

    const tooltipContent = (() => {
        if (closedAt) {
            return `Closed at: ${formatDateTime(closedAt)}`;
        }

        if (liveDate) {
            return `Linked since: ${formatDateTime(liveDate)}`;
        }
    })();

    return isEmpty(tooltipContent) ? (
        <>{badge}</>
    ) : (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div>{badge}</div>
                </TooltipTrigger>
                <TooltipContent>{tooltipContent}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
